import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/en/services/toxicology/")({
  beforeLoad: () => { throw redirect({ href: "/en/services/regulatory-toxicology", statusCode: 301 }); },
});
